import React, { useMemo, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { User, Tag, Calendar, ArrowLeft } from 'lucide-react';
import { getBlogsData } from '../data/blogsData';
import './BlogDetail.css';

const BlogDetail = () => {
  const { slug } = useParams();
  const { t } = useTranslation();

  const posts = useMemo(() => getBlogsData(t), [t]);
  const post = useMemo(() => posts.find((item) => item.slug === slug), [posts, slug]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) {
    return (
      <section className="blog-detail section-padding">
        <div className="container">
          <div className="blog-detail-not-found">
            <h2>{t('blog_not_found', 'Blog post not found')}</h2>
            <Link to="/blogs" className="back-link">
              <ArrowLeft size={18} /> {t('back_to_blogs', 'Back to Blogs')}
            </Link>
          </div>
        </div>
      </section>
    );
  }

  const { title, image, author, category, date, content } = post;
  const formattedDate = `${date.day} ${date.month}`;
  const bodyContent = (content && content.trim().length > 0 ? content : title || '').split('\n');

  return (
    <article className="blog-detail">
      <div className="blog-detail-hero" style={{ backgroundImage: `url(${image})` }}>
        <div className="blog-detail-overlay" />
        <div className="container">
          <div className="blog-detail-hero-content">
            <span className="blog-detail-category">{category}</span>
            <h1>{title}</h1>
            <div className="blog-detail-meta">
              <span><User size={16} /> {author}</span>
              <span><Calendar size={16} /> {formattedDate}</span>
              <span><Tag size={16} /> {category}</span>
            </div>
          </div>
        </div>
      </div>

      <section className="blog-detail-body section-padding">
        <div className="container">
          <div className="blog-detail-content">
            {bodyContent.map((paragraph, index) => {
              const text = paragraph.trim();
              if (!text) return null;
              return <p key={index}>{text}</p>;
            })}
            <Link to="/blogs" className="back-link">
              <ArrowLeft size={18} /> {t('back_to_blogs', 'Back to Blogs')}
            </Link>
          </div>
        </div>
      </section>
    </article>
  );
};

export default BlogDetail;
